<div class="app-version font-extra-small text-monospace" [ngClass]="{ 'elegant-text': dark, 'white-text': !dark }">
  <strong>[{{ version }}]</strong>
</div>